// extracted by mini-css-extract-plugin
module.exports = {"card-image":"storyHeroImage-m__card-image__ZvR6P","image-caption":"storyHeroImage-m__image-caption__2MkHz","attribute":"storyHeroImage-m__attribute__1_jvO"};